<template>
	<div>
		<div class="header bg-white text-center">
			<!-- <img :src="logo" class="header-logo img-fluid ml-3" v-if="logo"> -->
			<h1 class="header-title d-inline-block m-0" v-if="headerTitle">
				{{ headerTitle }}
			</h1>
		</div>
	</div>
</template>

<script>
	// import axios from "axios"
	export default {
		// data() {
		// 	return {
		// 		error: [],
		// 		config: [],
		// 		logo: "",
		// 		title: ""
		// 	}
		// },
		props: {
			headerTitle: {
				type: String,
			},
		},
		// created () {
		// 	axios({
		// 		method: "get",
		// 		url: "/site/api/v1/config"
		// 	})
		// 	.then(response => {
		// 		this.config = response.data
		// 		this.title = this.config.title
		// 		this.logo = this.config.settings.logo
		// 	})
		// 	.catch((err) => {
		// 		this.error.push(err.response)
		// 	})
		// },
	}
</script>

<style>
.header { padding: 10px; display: flex; align-items: center; justify-content: center; height: 66px; position: fixed; top: 0; right: 0; left: 0; z-index: 10; box-shadow: 0 0 5px rgba(0,0,0,0.1); }
.header-logo { height: 30px; }
.header-title { font-size: 1.2rem; font-weight: 700; color: #3b3b3b; }
</style>